module.exports = __webpack_public_path__ + "img/purpose.9b69c9e5.png";